import Timeago from 'stimulus-timeago'
import { de } from 'date-fns/locale'

export default class extends Timeago {
  get locale () {
    return de
  }
}
